module.exports = __webpack_public_path__ + "media/tts_g1_c.abbe58e8.mp3";